import type { HttpAdapter } from "../core/adapters/axios.adapter";
import { type PaymentsDO } from "./profile.models";

export class ProfileService {
    constructor(private paymentsAdapter:HttpAdapter){}

    async getBillingData(): Promise<PaymentsDO | null> {
        const response = await this.paymentsAdapter.get<PaymentsDO>('/');
        if (response.status !== 200) {
            return null;
        }
        return response.data as PaymentsDO;
    }
}
